import { render, staticRenderFns } from "./NotificationCrmLeadCommentPublish.vue?vue&type=template&id=31fc97f0&lang=pug&"
import script from "./NotificationCrmLeadCommentPublish.vue?vue&type=script&lang=js&"
export * from "./NotificationCrmLeadCommentPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports